import styled from '@emotion/styled';

export const SPiesCnt = styled.div`
  display: grid;
  grid-template-columns: 3fr 4fr;
  grid-gap: 16px;
`;
